import { BtButton, BtModal, BtText } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { CloseLines, TrashIcon } from '../../../../../../assets/icons'

import projectsStore from '../../../../Store'

import { styles } from './styles'

type InvoiceWasDeletedProps = {
  visible?: boolean
  setVisible?: any
  projectName: string | null | undefined
}

export const InvoiceWasDeleted = observer((props: InvoiceWasDeletedProps) => {
  const { t } = useTranslation('global')

  const { projectName = false, visible, setVisible } = props

  const { resetRefresher } = projectsStore

  const closeModal = () => {
    setVisible(false)
    resetRefresher()
  }

  return (
    <BtModal
      visible={visible}
      onClose={closeModal}
      containerStyle={styles.containerStyle}
      onBackdropPress={closeModal}
    >
      <BtButton style={styles.closeButton} onPress={closeModal}>
        <CloseLines height={10} width={10} />
      </BtButton>
      <View style={styles.mainContent}>
        <TrashIcon />
        <BtText style={styles.title}>
          {t('Projects.InvoiceRemoved' as any)}
        </BtText>
        <BtText style={styles.subtitle}>
          {projectName} {t('Projects.wasPermanentRemoved' as any)}
        </BtText>
        <BtButton style={styles.button} onPress={closeModal} size="giant">
          {t('Projects.okay')}
        </BtButton>
      </View>
    </BtModal>
  )
})
